import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { LoginResponse, Member, SignupPayload } from '../models/member.model';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private http = inject(HttpClient);
  private router = inject(Router);
  private apiUrl = environment.apiUrl + '/auth';

  constructor() {
    this.restoreSession();
  }

  private restoreSession() {
    // Restore from sessionStorage on service init
  }

  isLoggedIn(): boolean {
    return !!sessionStorage.getItem('token');
  }

  getToken(): string {
    return sessionStorage.getItem('token') || '';
  }

  getUserRole(): string {
    return sessionStorage.getItem('role') || '';
  }

  getUserName(): string {
    return sessionStorage.getItem('userName') || '';
  }

  getUserEmail(): string {
    return sessionStorage.getItem('userEmail') || '';
  }

  isPowerUser(): boolean {
    return sessionStorage.getItem('isPowerUser') === 'true';
  }

  getUserInitials(): string {
    const name = this.getUserName();
    if (!name) return '?';
    const parts = name.split(' ');
    return parts.map(p => p.charAt(0).toUpperCase()).join('').slice(0, 2);
  }

  setUserDetails(data: LoginResponse) {
    sessionStorage.setItem('token', data.token);
    sessionStorage.setItem('role', data.user.role);
    sessionStorage.setItem('userName', `${data.user.firstName} ${data.user.lastName || ''}`.trim());
    sessionStorage.setItem('userEmail', data.user.emailId);
    sessionStorage.setItem('userId', data.user._id);
    sessionStorage.setItem('isPowerUser', String(!!data.user.isPowerUser));
  }

  signOut() {
    sessionStorage.clear();
    this.router.navigate(['/signin']);
  }

  // API calls
  login(payload: { emailId: string; password: string }): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.apiUrl}/login`, payload);
  }

  signup(payload: SignupPayload): Observable<any> {
    return this.http.post(`${this.apiUrl}/signup`, payload);
  }

  logout(): Observable<any> {
    return this.http.post(`${this.apiUrl}/logout`, {});
  }

  getMe(): Observable<Member> {
    return this.http.get<Member>(`${this.apiUrl}/me`);
  }
}
